import React from "react";
import { state } from "../../interfaces/interfaces";
import subscriptions from "@services/subscriptions/instance";
import { useAppSelector } from "@store/hooks";
import { authService, ExtUser } from '../../services/authorizationService';

export interface IAuthContext {
    userId: number | null;
    isAuthenticated: boolean;
    subscribe: () => void;
    unsubscribe: () => void;
    setIsAuthenticated: (isAuthenticated: boolean) => void;
    setUser: (user: ExtUser) => void;
    authenticate: () => Promise<void>;
}

const subscribe = () => {
    subscriptions.subscribe('IsAuthenticated', "AuthProvider", (isAuthenticated: boolean) => {
        state.IsAuthenticated = isAuthenticated;
    });

    subscriptions.subscribe('User', "AuthProvider", (user: ExtUser) => {
        if (!user) { state.UserId = -1; return; }
        state.UserId = Number(user.profile.user_id);
    });
}

const unsubscribe = () => {
    subscriptions.unsubscribe('IsAuthenticated', "AuthProvider");
    subscriptions.unsubscribe('User', "AuthProvider");
}

const setIsAuthenticated = (isAuthenticated: boolean) => {
    subscriptions.publish('IsAuthenticated', isAuthenticated);
}


const setUser = (user: ExtUser) => {
    subscriptions.publish('User', user);
}


const authenticate = async () => {
    console.log("Authenticating...");
    await authService.isAuthenticated()
}

// create authProvider Context and Provider 
const AuthContext = React.createContext<IAuthContext>({
    isAuthenticated: false,
    userId: null,
    subscribe: subscribe,
    unsubscribe: unsubscribe,
    setIsAuthenticated: setIsAuthenticated,
    authenticate: authenticate,
    setUser: setUser
});

interface IAuthProviderProps {
    children: React.ReactElement;
}


const AuthProvider: React.FC<IAuthProviderProps> = ({ children }) => {
    const isAuthenticated = useAppSelector(({ state }) => state.IsAuthenticated);
    const userId = useAppSelector(({ state }) => state.UserId);
    const [called, setCalled] = React.useState(false);
    
    React.useEffect(() => {
        subscribe();
        
        const subscription = authService.subscribe((isAuthenticated, user) => {
            setIsAuthenticated(isAuthenticated);
            setUser(user);
        })

        if (!isAuthenticated && !called) {
            authenticate();
            setCalled(true);
        }

        return () => {
            authService.unsubscribe(subscription);
            unsubscribe()
        }
    }, [called, isAuthenticated]);

    return (
        <AuthContext.Provider value={{ isAuthenticated, userId, subscribe, unsubscribe, setIsAuthenticated, authenticate, setUser }}>
            {children}
        </AuthContext.Provider>
    )
}

export { AuthProvider, AuthContext };